<template>
  <div>
    <div class="d-flex align-center">
      <h2>出欠管理</h2>
      <v-spacer />
      <v-btn
        @click="selectBtn"
        :loading="loading"
        :close-on-content-click="false"
        color="primary"
        variant="outlined"
        class="mr-4"
      >
        <v-icon start>mdi-tray-arrow-down</v-icon>
          ダウンロード
        <v-row class="selectDL">
          <v-btn
            @click="monthly"
            v-model="monthlyDownload"
            v-if="selectDownload"
            color="primary"
            variant="text"
            class="btnDL mt-4"
          >
            出席簿(月次)
          </v-btn>
          <v-btn
            @click="daily"
            v-model="dailyDownload"
            v-if="selectDownload"
            color="primary"
            variant="text"
            class="btnDL mt-4"
          >
            出席簿(日次)
          </v-btn>
        </v-row>
      </v-btn>
      <v-btn
        @click="searchAttendance"
        :loading="loading"
        color="primary"
        variant="outlined"
      >
        <v-icon start>mdi-sync</v-icon>
        更新
      </v-btn>
    </div>

    <v-row>
      <date-pager v-model="searchFilters.date" class="pt-4"></date-pager>
    </v-row>

    <div class="d-flex align-bottom my-6">
      <div class="mr-8">
        <div class="font-weight-bold">現在の園児人数</div>
        <div class="mt-2 font-weight-bold">
          <span style="font-size: 40px">{{
            attendances ? (attendances.summary.presentChildrenCount - startCount) : 0
          }}</span>
          / {{ attendances ? attendances.summary.totalChildrenCount : 0 }}
        </div>
      </div>
      <div class="mr-8">
        <div class="font-weight-bold">おやすみ</div>
        <div class="mt-2 font-weight-bold">
          <span style="font-size: 40px">{{
            attendances ? attendances.summary.absentChildrenCount : 0
          }}</span>
        </div>
      </div>
    </div>

    <v-card variant="flat" class="mt-4 pa-2" color="grey-lighten-5">
      <v-container>
        <v-row>
          <v-col cols="3">
            <h5>クラス</h5>
            <v-select
              v-model="searchFilters.classId"
              :items="classes"
              :item-title="(item) => `(${item.year}) ${item.className}`"
              item-value="classId"
              variant="outlined"
              hide-details
              density="compact"
              clearable
              :disabled="loading"
              color="primary"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <h5>出欠状況</h5>
            <v-select
              v-model="searchFilters.status"
              :items="statusItems"
              item-title="text"
              item-value="value"
              variant="outlined"
              hide-details
              density="compact"
              :disabled="loading"
              clearable
              color="primary"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <h5>性別</h5>
            <v-select
              v-model="searchFilters.gender"
              :items="genderItems"
              item-title="text"
              item-value="value"
              variant="outlined"
              hide-details
              density="compact"
              :disabled="loading"
              clearable
              color="primary"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <h5>年齢</h5>
            <v-select
              v-model="searchFilters.age"
              :items="ageItems"
              item-title="text"
              item-value="value"
              variant="outlined"
              hide-details
              density="compact"
              :disabled="loading"
              clearable
              color="primary"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-table class="pt-4" v-if="attendances">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">園児氏名</th>
            <th class="text-left">出欠状況</th>
            <th class="text-left">登園時刻</th>
            <th class="text-left">降園時刻</th>
            <!-- <th class="text-left">発熱予測</th> -->
            <th class="text-left">クラス名</th>
            <th class="text-left">性別</th>
            <th class="text-left">年齢</th>
            <th class="text-left"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="a in attendances.attendances" :key="a.child.childId">
            <td>{{ a.child.lastName }} {{ a.child.firstName }}</td>
            <td>
              <div v-if="a.status == 'isAbsent'" style="color: deeppink;">
                {{ getStatusText(a.status) }}
              </div>
              <div v-else>
                {{ getStatusText(a.status) }}
              </div>
            </td>
            <td>{{ a.attendedAt ? formatDate(a.attendedAt) : "-" }}</td>
            <td>{{ a.leftAt ? formatDate(a.leftAt) : "-" }}</td>
            <!--
            <td>
              <div v-if="a.isFeverAlert == 'FEVER'">
                <v-chip small color="error" label> 発熱予測 </v-chip>
              </div>

              <div v-else-if="a.isFeverAlert == 'MODEST_FEVER'">
                <v-chip small color="orange" text-color="white" label>
                  微熱予測
                </v-chip>
              </div>

              <div v-else>-</div>
            </td> 
            -->
            <td>{{ getClassName(a.child) }}</td>
            <td>
              <v-chip
                v-if="a.child.gender == 'male'"
                color="blue"
                variant="tonal"
                dark
                small
                >男性</v-chip
              >

              <v-chip v-else color="pink lighten-2" variant="tonal" dark small>女性</v-chip>
            </td>
            <td>{{ getAgeBasedonBirthdate(a.child.dateOfBirth) + "歳" }}</td>
            <td>
              <v-btn
                color="primary"
                variant="flat"
                small
                :to="`/attendance/${a.child.childId}/${a.date}/edit`"
                :disabled="loading"
              >
                編集
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-table>

    <!--月次出席簿ダウンロード-->
    <v-dialog
      v-model="monthlyDownload"
      :close-on-content-click="false"
      max-width="645px"
    >
      <div class="d-flex align-center justify-center">
          <v-card class="DLMon">
            <v-card-title class="pb-6">{{ DLDate }}の月次出席簿のダウンロード</v-card-title>
            <v-row class="pt-6">
              <v-btn
                @click="monthlyDownload = false"
                color="grey"
                style="color: white"
              >
                キャンセル
              </v-btn>
              <v-spacer />
              <v-btn
                @click="monthlyBtnDL"
                color="primary"
              >
                OK
              </v-btn>
            </v-row>
          </v-card>
      </div>
    </v-dialog>

    <!--日次出席簿ダウンロード-->
    <v-dialog
      v-model="dailyDownload"
      :close-on-content-click="false"
      max-width="625px"
    >
      <div class="d-flex align-center justify-center">
          <v-card class="DLDay">
            <v-card-title class="pb-6">{{ DLDate }}の日次出席簿のダウンロード</v-card-title>
            <v-row class="pt-6">
              <v-btn
                @click="dailyDownload = false"
                color="grey"
                style="color: white"
              >
                キャンセル
              </v-btn>
              <v-spacer />
              <v-btn
                @click="dailyBtnDL"
                color="primary"
              >
                OK
              </v-btn>
            </v-row>
          </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DatePager from "@/components/atoms/DatePager.vue";
import LocalDataService from "@/service/LocalDataService";
import { classModule } from "@/store/dataModules/classModule";
import {
  NurseryChildResponse,
  NurseryClassResponse,
  SearchNurseryAttendanceResponse,
} from "chaild-api/lib";
import { ageItems, genderItems, statusItems } from "@/constants/attendance";
import { attendanceModule } from "@/store/dataModules/attendanceModule";
import dayjs from "dayjs";
import CommonUtil from "@/utils/CommonUtil";

export default defineComponent({
  name: "AttendanceList",

  components: {
    DatePager,
  },

  watch: {
    searchFilters: {
      deep: true,
      async handler() {
        await this.searchAttendance();
      },
    },
    'searchFilters.date'(newDate, oldDate) {
      sessionStorage.setItem('attendancedate', newDate);
    },
    monthlyDownload(value) {
      if (value == false) {
        this.monthlyDownload = false;
      }
      if (this.monthlyDownload == false && this.dailyDownload == false) {
        this.selectDownload = false;
      }
    },
    dailyDownload(value) {
      if (value == false) {
        this.dailyDownload = false;
      }
      if (this.monthlyDownload == false && this.dailyDownload == false) {
        this.selectDownload = false;
      }
    },
  },

  async mounted() {
    const attendancedate = sessionStorage.getItem('attendancedate')
    const queries = this.$route.query
    if (queries.date) {
      const dateString = queries.date as string
      const date = dayjs(dateString).format('YYYY-MM-DD')
      this.searchFilters.date = date
    } else {
      const date = dayjs().format('YYYY-MM-DD')
      this.searchFilters.date = date
    }

    if (attendancedate) {
      this.searchFilters.date = attendancedate;
    }

    await this.searchAttendance();
    await this.listClasses();
  },

  data() {
    return {
      loading: false,
      searchFilters: {
        date: dayjs().format("YYYY-MM-DD"),
        age: undefined as number | undefined,
        classId: undefined as string | undefined,
        gender: undefined as string | undefined,
        status: undefined as string | undefined,
        limit: 1000,
        skip: 0,
      },
      genderItems: genderItems,
      ageItems: ageItems,
      statusItems: statusItems,
      selectDownload: false,
      monthlyDownload: false,
      dailyDownload: false,
      DLDate: '',
    };
  },

  computed: {
    classes: function (): NurseryClassResponse[] {
      return classModule.classes;
    },
    attendances: function (): SearchNurseryAttendanceResponse | null {
      return attendanceModule.attendances;
    },
    startCount: function (): number {
      if (this.attendances?.attendances) {
        let count = 0;
        for (let i = 0; i < this.attendances.attendances.length; i++) {
          if (this.attendances.attendances[i].leftAt) {
            count++;
          }
        }
        return count;
      }
      return 0;
    },
  },

  methods: {
    async listClasses() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await classModule
          .listClass({
            nurseryId,
          })
          .catch();
      }
      this.loading = false;
    },
    async searchAttendance() {
      this.loading = true;
      this.selectDownload = false
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await attendanceModule
          .searchAttendance({
            nurseryId,
            ...this.searchFilters,
          })
          .catch();
      }
      this.loading = false;
    },
    formatDate(date: string | null | undefined) {
      if (date) {
        return dayjs(date).format("HH:mm");
      }
      return null;
    },
    getClassName(child: NurseryChildResponse) {
      if (child.nurseryClasses) {
        const year = CommonUtil.getFiscalYear(this.searchFilters.date);
        const currentClass = child.nurseryClasses.find(
          (c) => String(c.year) == year
        );
        if (currentClass) {
          return currentClass.className;
        }
      }
      return "不明なクラス";
    },
    getAgeBasedonBirthdate(birthdate: string): number {
      const thisYear = dayjs();
      return thisYear.diff(birthdate, "year");
    },
    getStatusText(value: string): string {
      if (!value) {
        return "";
      }
      return statusItems.find((s) => s.value == value)?.text || "";
    },
    selectBtn() {
      if (this.selectDownload && this.monthlyDownload == false && this.dailyDownload == false) {
        this.selectDownload = false
      } else {
        this.selectDownload = true
      }
    },
    monthly() {
      this.monthlyDownload = true
      this.DLDate = dayjs(this.searchFilters.date).format('YYYY年MM月')
    },
    daily() {
      this.dailyDownload = true
      this.DLDate = dayjs(this.searchFilters.date).format('YYYY年MM月DD日')
    },
    // 月次出席簿のダウンロード
    async monthlyBtnDL() {
      this.loading = true
      this.monthlyDownload = false
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await attendanceModule.DownloadAttendance({
          nurseryId: nurseryId,
          date: this.searchFilters.date,
          category: "attendance_summary"
        })
        this.loading = false
        return alert('エクスポートを開始しました。\nダウンロード一覧画面からご確認ください。\n※完了まで1-2分程度かかる場合があります。');
      }
      this.loading = false
      return alert('エクスポートに失敗しました');
    },
    // 日次出席簿のダウンロード
    async dailyBtnDL() {
      this.loading = true
      this.dailyDownload = false
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await attendanceModule.DownloadAttendance({
          nurseryId: nurseryId,
          date: this.searchFilters.date,
          category: "attendance"
        })
        this.loading = false
        return alert('エクスポートを開始しました。\nダウンロード一覧画面からご確認ください。\n※完了まで1-2分程度かかる場合があります。');
      }
      this.loading = false
      return alert('エクスポートに失敗しました');
    },
  },
});
</script>

<style lang="scss" scoped>
.filter-caption {
  font-size: 0.9rem;
}

.selectDL {
  top: 40px;
  position: absolute;
}

.btnDL {
  width: 145px;
}

.DLMon {
  padding: 60px 88px;
  text-align: center;
}

.DLDay {
  padding: 60px 88px;
  text-align: center;
}
</style>
